import styled from 'styled-components';
import LoadingIndicator from '../../../assets/image/LoadingIndicator.gif';
import { colors } from '../../../theme/style-helpers';

export const LoaderWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${colors.GREY_LIGHTEST};
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const LoadingGif = styled.img.attrs(() => ({ src: LoadingIndicator }))`
  height: 80px;
  width: 160px;
  margin-bottom: 24px;
`;

export const ContentContainer = styled.div`
  text-align: center;
  min-width: 250px;
`;
